<div class="dialog-shell">
    <div class="dialog-head">
        <div class="dialog-head__top">
            <h1 mat-dialog-title class="dialog-title">Privacy</h1>
            <button
                mat-icon-button
                mat-dialog-close
                class="button-close--outlined"
                color="primary"
                aria-label="Chiudi"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <p class="dialog-subtitle">Scegli come possiamo trattare i tuoi dati personali. Puoi modificare i consensi quando vuoi.</p>

        <a (click)="navigatePrivacyPolicy()" class="link privacy-doc" tabindex="0">
            <mat-icon class="privacy-doc-icon">description</mat-icon>
            <span class="text-lg privacy-doc-label">Visualizza documento di Privacy</span>
            <mat-icon class="privacy-doc-arrow">arrow_forward</mat-icon>
        </a>
    </div>

    <div mat-dialog-content class="dialog-body">
        <form [formGroup]="formGroup" (ngSubmit)="onYesClick()" class="dialog-form">
            <div class="consent-list">
                <div class="fo-card consent-row">
                    <p class="consent-text">
                        Acconsento al trattamento dei miei dati personali di contatto per ricevere comunicazione dal Titolare circa
                        nuovi servizi e/o proposte rivolte dal Titolare agli iscritti alla Piattaforma.
                    </p>
                    <mat-slide-toggle
                        formControlName="privacy_communications"
                        aria-label="Consenso alle comunicazioni del Titolare"
                    ></mat-slide-toggle>
                </div>

                <div class="fo-card consent-row">
                    <p class="consent-text">
                        Acconsento alla comunicazione dei miei dati personali di contatto a società terze per ricevere da queste
                        ultime offerte e/o comunicazioni appositamente dedicate a soggetti non udenti.
                    </p>
                    <mat-slide-toggle
                        formControlName="privacy_third_part"
                        aria-label="Consenso alla comunicazione dei dati a società terze"
                    ></mat-slide-toggle>
                </div>

                <div class="fo-card consent-row is-required">
                    <p class="consent-text">
                        Autorizzo il trattamento dei miei dati personali necessari per potere accedere alla Piattaforma e per
                        consentire la navigazione al suo interno in base e per le finalità riportate nella correlata Informativa. *
                    </p>
                    <mat-slide-toggle
                        formControlName="privacyaccept"
                        required
                        aria-label="Autorizzazione al trattamento dei dati personali, obbligatoria"
                    ></mat-slide-toggle>
                </div>
            </div>

            <p class="consent-note">I campi contrassegnati con * sono obbligatori.</p>

            <div class="dialog-footer">
                <button type="submit" class="fo-btn fo-btn--primary fo-btn--block" [disabled]="!formGroup.valid">
                    Salva Modifiche
                </button>
            </div>
        </form>
    </div>
</div>
